import type { PhotoGridItemDimensions, PhotoGridItemOffset } from '../types';

export function getImgixParamsFromProps({
  aspectRatio,
  offset,
  trimColor,
  zoom,
}: {
  aspectRatio: PhotoGridItemDimensions;
  offset: PhotoGridItemOffset;
  trimColor: string;
  zoom: number;
}): string {
  const queryParams = new URLSearchParams();
  queryParams.set('ar', `${aspectRatio.width}:${aspectRatio.height}`);
  queryParams.set('crop', 'focalpoint');
  queryParams.set('fit', 'crop');
  queryParams.set('fp-x', offset.x.toString());
  queryParams.set('fp-y', offset.y.toString());
  queryParams.set('fp-z', zoom.toString());
  if (trimColor) queryParams.set('trim-color', trimColor.replace('#', ''));
  return queryParams.toString();
}
